<template>
  <tab-list
      v-model="currentTab"
      :tabs-enum="tabs"
      :title="title"
      fixed-tabs
      :default-tab="defaultTab"
      @change="changeTab">
    <template v-slot:tabItem="{ current }">
      <general-error v-if="!!generalError" />
      <lot-list
          :lot-status="current"
          :privacy-type="privacyType" />
    </template>
  </tab-list>
</template>

<script>
  import LotList from '@/components/reused/lot/LotList.vue'
  import TabList from '@/components/reused/ui/TabList.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { LOT_STATUS_TYPE_ENUM } from '@/constants/enums'
  import { LOT_STATUSES, PRIVACY_TYPES } from '@/constants/business'

  export default {
    components: {
      TabList,
      LotList,
      GeneralError
    },
    props: {
      tab: {
        type: String
      }
    },
    data () {
      return {
        privacyType: PRIVACY_TYPES.PERSONAL,
        currentTab: this.tab || LOT_STATUSES.DRAFT
      }
    },
    computed: {
      title () {
        return this.isAdmin
          ? this.$t('Управление торговыми процедурами')
          : this.$t('Список торговых процедур с моим участием')
      },
      tabs () {
        return { ...LOT_STATUS_TYPE_ENUM }
      },
      defaultTab () {
        return LOT_STATUSES.DRAFT
      }
    },
    methods: {
      changeTab: function (tabValue) {
        this.replaceCurrentRoute(this.getRoute(tabValue))
      },
      getRoute: function (tabValue) {
        return `${this.urlRootPath}/lots/${this.privacyType}/${tabValue}`
      }
    }
  }
</script>
